import React from 'react';
import 'react-block-ui/style.css';
import LaddaButton, { S, SLIDE_LEFT } from 'react-ladda';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import store from '../../../../stores/store';
import _ from 'lodash';
import {
    PAIRCOMPANY_EXPIRE_MSG,
    PAIRCOMPANY_INVALID_MSG,
    PAIRCOMPANY_INITAL_MSG,
    DEFAULT_ERROR_MSG,
} from '../../../../helpers/messageText';

class CompanyPairing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            pending: false,
            error: '',
        };
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal,
            error: '',
        });
    };

    addCompany = event => {
        event.preventDefault();
        this.setState({
            pending: true,
        });

        store.companies
            .pairCompany(this.input.value)
            .then(json => {
                store.companies.fetch();
                this.setState({
                    pending: false,
                });
                this.toggle();
            })
            .catch(error => {
                this.setState({
                    pending: false,
                    error: this.getPairCompanyErrorMessage(error)
                });
            });
    };

    getPairCompanyErrorMessage = error => {
        const errorMessage = _.get(error.spread, 'Details.Error', DEFAULT_ERROR_MSG);
        switch (errorMessage) {
            case 'User not found or the invitation expired!':
                return PAIRCOMPANY_EXPIRE_MSG;

            case 'Not valid!':
                return PAIRCOMPANY_INVALID_MSG;

            default:
                return PAIRCOMPANY_INVALID_MSG;
        }
    };

    render() {
        return (
            <div className="col-xs-auto text-right">
                <a className="add-company-btn add-company-icon" onClick={this.toggle}>
                    Add company
                </a>
                <Modal
                    className="modal-lg"
                    isOpen={this.state.modal}
                    toggle={this.toggle}
                    autoFocus={false}
                >
                    <ModalHeader>
                        <p className="modal-title">
                            Add a new company to Boardtrac existing account
                        </p>
                    </ModalHeader>
                    <ModalBody>
                        <div className="text-left">
                            {this.state.error !== '' ? (
                                <div className="alert alert-danger" role="alert">
                                    {this.state.error}
                                </div>
                            ) : (
                                <p>{PAIRCOMPANY_INITAL_MSG}</p>
                            )}
                            <div className="form-group col-md-6 col-lg-4">
                                <input
                                    className="form-control"
                                    type="text"
                                    maxLength="6"
                                    ref={input => (this.input = input)}
                                    id="pair-company-access-code"
                                    autoFocus
                                />
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <a
                            className="btn btn-outline-primary"
                            data-dismiss="modal"
                            onClick={this.toggle}
                            disabled={this.state.pending}
                        >
                            Cancel
                        </a>
                        <LaddaButton
                            className="btn btn-primary"
                            loading={this.state.pending}
                            onClick={this.addCompany}
                            disabled={this.state.pending}
                            data-size={S}
                            data-style={SLIDE_LEFT}
                            data-spinner-size={30}
                            data-spinner-color="#fff"
                            data-spinner-lines={12}
                        >
                            Add company
                        </LaddaButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default CompanyPairing;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Company/components/CompanyPairing.js